import { useMediaQuery } from 'react-responsive';
import { Queries } from '@ers/data';

const useMedia = () => {
    const isPhone = useMediaQuery({ query: Queries.phone });
    const isTabletPortrait = useMediaQuery({ query: Queries.tabletPortrait });
    const isTabletLandscape = useMediaQuery({ query: Queries.tabletLandscape });
    const isDesktop = useMediaQuery({ query: Queries.desktop });
    const isFullHD = useMediaQuery({ query: Queries.fullHD });
    return { isPhone, isTabletPortrait, isTabletLandscape, isDesktop, isFullHD };
};

export default useMedia;